import { formatDateToDDMMYYYYHHMM } from "@/helpers/Dates";
import { IRequestDataForIP } from "@/interfaces/passkeys";
import { BasicButton } from "thrive-components";



function RequestMessagePanel({request, onClearMessage}: {request: IRequestDataForIP, onClearMessage: ()=>void}) {
    return (
        <span className="full-request-message-wrapper">
            <div className="top-panel">
                <span className="view-message-text">
                    Viewing message from {formatDateToDDMMYYYYHHMM(request.createdAt)}
                </span>

                <BasicButton 
                    className="back-to-messages"
                    ariaLabel={"Back to messages"}
                    onButtonClick={onClearMessage} 
                    content={"Back to messages"}
                />
            </div>

            <span className="full-message-text">
                {request.message}
            </span>
        </span>
    );
}

export default RequestMessagePanel;